import { brandlistdata } from "../json/brandlistdata";
import { dashboarrecentproductddata } from "../json/dashboarddata";
import { salestransaction } from "../json/salesdashboardrecenttranscation";
import { ManageStocksdata } from "../json/managestocks_data";
import { userlisadata } from "../json/users";
import { leavetypedata } from "../json/leavetypedata";
import { lowstockdata } from "../json/lowstockdata";


const initialState = {
  product_list: [],
  dashboard_recentproduct: dashboarrecentproductddata,
  saleshdashboard_recenttransaction: salestransaction,
  brand_list: brandlistdata,
  toggle_header: true,
  managestockdata: ManageStocksdata,
  userlist_data: userlisadata,
  leavetypes_data: leavetypedata,
  lowstock_data: lowstockdata,
  layoutstyledata: localStorage.getItem("layoutStyling"),
};

export default initialState;
